import axios from "axios";

// In production the React app is served by the same Express server,
// so all API calls use a relative base URL ("/api").
// In development (npm start) REACT_APP_API_URL points to localhost:4000.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
});

// Attach JWT token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cff_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
